// extracted by mini-css-extract-plugin
module.exports = {"empty-view-text":"style_empty-view-text__dSrYX"};